export default "__VITE_ASSET__CgRBgOXV__"